module.exports = "/images/maestro.svg";